var _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConductorLungBulina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 80,
    viewBox: "0 0 139 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 39.25,
    x2: 139,
    y2: 39.25,
    stroke: "black",
    strokeWidth: 3.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 40.5,
    r: 7.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConductorLungBulina);
export default __webpack_public_path__ + "static/media/conductor_lung_bulina.156b5da9b117f5476744fd1ef99d28c8.svg";
export { ForwardRef as ReactComponent };